import EducationCounter from "./Reusable/EducationCounter";
import React from "react";
import { useSelector } from "react-redux";
import Header from "./Header";
import Footer from "./Footer";

const EducationHolder = (props) => {
  const { educationDetail, educationItemsList } = useSelector(
    (state) => state.educationReducer
  );
  return (
    <div>
      <Header nameClass="backgorund-color-header" />
      <div className="education-header-mask"></div>
      <div className="education-counter-holder">
        <EducationCounter
          educationDetail={educationDetail}
          educationItemsList={educationItemsList}
        />
      </div>
      {props.children}
      <div className="education-footer-mask"></div>
      <Footer />
    </div>
  );
};

export default EducationHolder;
